/**
 * Callback function used to navigate to a different module.It checks the uuid sent by the childframe with the stored chatbotId, makes sure the event type is 'navigate', and makes sure the identifier is a string.
 *
 * @param {Object} ev - event from chatbot containing the dialNumber event type, uuid, and phone number to dial.
 * @param {Object} ev.data - data being passed by the chatbot to the M2 application
 * @param {string} ev.data.type - type of event being sent by the chatbot. Should be 'dialNumber'.
 * @param {string} ev.data.uuid - uuid of the chatbot frame.
 * @param {Object} ev.data.payload - payload from the child frame.
 * @param {string} ev.data.payload.number - string with the module where we're going to navigate to.
 */
var dailNumberCallback = function dailNumberCallback(_ref) {
  var _ref$data = _ref.data,
      type = _ref$data.type,
      uuid = _ref$data.uuid,
      number = _ref$data.payload.number;

  if (type === 'dialNumber' && uuid && window.WF_CHATBOT.uuid === uuid && typeof number === 'string') {
    // eslint-disable-next-line
    window.location.href = "tel:".concat(number);
  }
};
/**
 * Adds event listener to open the dial number dialog.
 */


export var addDialNumberEvent = function addDialNumberEvent() {
  window.WFUI_BRIDGE.registerEventListener('dialNumber', dailNumberCallback, window.WF_CHATBOT.uuid);
};